export default __webpack_public_path__ + "static/media/chevron-down-right.c3c2b6b4.svg";